import { PROVIDERS } from 'common/providers'

export default {
    spiludviklere: 'Spiludviklere',
    ...PROVIDERS.reduce(
        (res, value) => ({ ...res, [value.name]: value.label }),
        {}
    ),
}
